'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

function BifunctorExtensions(B) {
  var mapLeft = function (aToC, fab) {
    return Curry._3(B.bimap, aToC, (function (b) {
                  return b;
                }), fab);
  };
  var mapRight = function (bToD, fab) {
    return Curry._3(B.bimap, (function (a) {
                  return a;
                }), bToD, fab);
  };
  return {
          mapLeft: mapLeft,
          mapRight: mapRight,
          mapError: mapRight
        };
}

function BifunctorInfix(B) {
  return {
          $less$less$$great$great: B.bimap
        };
}

exports.BifunctorExtensions = BifunctorExtensions;
exports.BifunctorInfix = BifunctorInfix;
/* No side effect */
